export default __webpack_public_path__ + "static/media/boost_async_ext_mosfet.33d1f221.svg";